import { generateReadActionCreator, generateReadOneActionCreator } from '../crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';
import routes from 'actions/routes';

export default {
    readCatalog: generateReadActionCreator(routes.API_PRODUCT_CATALOG, ACTION_NAMES.PRODUCT_CATALOG),
    readProductSummary: generateReadOneActionCreator(routes.API_PRODUCT, ACTION_NAMES.PRODUCT_CATALOG, 'summary')
}
